import React, { Component, Fragment }  from 'react'
import styled from 'styled-components'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import { Title, ButtonContainer } from '../../healtheraComponents'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

class ChangePasswordDialog extends Component {

  state = { old_password: '', user_password: '', confirm_password: '', disabled: true }

  onChange(key, e) {
    const { old_password, user_password, confirm_password} = this.state
    this.setState({ [key]: e.target.value })
    if (user_password && confirm_password && old_password)
      this.setState({ disabled: false})
  }

  handleClose() { this.props.onClose() }

  handleSumbit() {
    const { user_password, confirm_password, old_password } = this.state
    if (user_password !== confirm_password) 
      return alert('Your passwords do not match')

    this.props.updateUserPassword(old_password, user_password)
    this.props.logout()
  }

  render() {
    const { open } = this.props
    return (
      <Fragment>
        <StyledDialog onClose={this.handleClose.bind(this)} open={open} aria-labelledby='legacy-branches' scroll={'paper'}>
          <Title margin={`20px 0 20px 0`} textAlign={'center'}>Change Password</Title>
          <DialogContent>
            <form>
            <Field onChange={this.onChange.bind(this, 'old_password')} required label='Old Password' type='password' margin='normal' />
            <Field onChange={this.onChange.bind(this, 'user_password')} required label='New Password' type='password' margin='normal' />
            <Field onChange={this.onChange.bind(this, 'confirm_password')} required label='Confirm New Password' type='password' margin='normal' />
            </form>
          </DialogContent>
            <ButtonContainer justify={`center`} padding={`20px`}>
              <DialogButton disabled={this.state.disabled} onClick={this.handleSumbit.bind(this)}>Reset Password</DialogButton>
            </ButtonContainer>
        </StyledDialog>
      </Fragment>
    )
  }
}

export default ChangePasswordDialog

const StyledDialog = styled(({ color, ...other }) => (
  <Dialog {...other} classes={{ paper: 'paper' }} />
))`
&& .paper {
  padding:22px 22px 20px 22px;
  width: 483px;
  height: 544px;
  border-radius: 22.5px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  box-sizing: border-box;
}
&& .paper div[class^="MuiDialogActions"] {
  justify-content:center;
}
&& .paper div[class^="MuiDialogActions-action"] div:first-child button  {
  margin-right:25px;
}
`
const DialogButton = styled(Button)`
&&
{
  width: 200px;
  height: 40px;
  border-radius: 20px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.28);
  color: white;
  background-color: #939393;
}
`
const Field = styled(TextField)`
&&
{
  width: 100%;
  margin-top: 40px;
}
`
